<template>
  <a-drawer
    :zIndex="997"
    placement="left"
    :wrapClassName="
      isMobile ? 'm-drawer m-drawer-notif' : 'm-drawer m-drawer-left2x m-drawer-notif'"
    :mask="isMobile ? true : false"
    :closable="false"
    :width="isMobile ? 340 : 400"
    @close="handleClose"
    :visible="visible"
  >
    <div slot="title" class="d-flex flex-row justify-between nowrap">
      <span> <a-icon type="notification" />&nbsp; Notifikasi </span>
      <a-button-group>
        <a-button
          v-if="cleanDisplay"
          @click="handleClean"
          size="small"
          type="danger"
          icon="delete"
          >Bersihkan</a-button
        >
        <!-- <a-button type="default" size="small">Riwayat</a-button> -->
        <a-button
          v-if="!isMobile"
          @click="handleClose"
          type="default"
          size="small"
          icon="close"
        ></a-button>
      </a-button-group>
    </div>

    <div class="m-drawer-body">
      <div class="search-wrapper">
        <a-input-search
          v-model="search"
          @pressEnter="onSearch"
          placeholder="Search Notification .. "
        />
      </div>
      <a-tabs v-model="activeKey" defaultActiveKey="aksi" class="m-tabs">
        <a-tab-pane class="m-tabs-pane" key="aksi">
          <div slot="tab">
            <a-badge
              :offset="[10, -2]"
              :count="notif.aksi.length"
              :overflowCount="10"
              :numberStyle="{ backgroundColor: '#52c41a' }"
            >
              <span>Aksi</span>
            </a-badge>
          </div>
          <template v-if="notif.aksi.length > 0">
            <div class="jos">
            <a-card
              hoverable
              class="m-card-notif m-bottom"
              v-for="aksi in notif.aksi"
              :key="aksi.id_notifikasi"
              @click="handleNotification(aksi)"
            >
              <template slot="title">
                <span class="m-remove"
                  >{{ aksi.keperluan }} {{ aksi.tlc_pembuat }}</span
                >
                <small class="m-text-dots">{{ aksi.invoice_no }}</small>
              </template>
              <div slot="extra">
                <!-- extra -->
                <a-tag color="red" v-if="aksi.aksi == 'Revised'"
                  >Need Revise</a-tag
                >
                <a-tag color="red" v-else-if="aksi.aksi == 'Approve'"
                  >Need Approve</a-tag
                >
              </div>
              <div>
                <span class="d-block"
                  >Tanggal Permohonan : {{ aksi.tgl_notif }}</span
                >
              </div>
            </a-card>
            </div>
          </template>
          <a-alert
            type="error"
            message="Tidak ada notifikasi yang memerlukan aksi kamu"
            banner
            v-else
          />
        </a-tab-pane>
        <a-tab-pane class="m-tabs-pane" key="informasi" forceRender>
          <div slot="tab">
            <a-badge
              :offset="[10, -2]"
              :count="notif.informasi.length"
              :overflowCount="10"
              :numberStyle="{ backgroundColor: '#52c41a' }"
            >
              <span>Informasi</span>
            </a-badge>
          </div>
          <template v-if="notif.informasi.length > 0">
            <a-card
              hoverable
              class="m-card-notif m-bottom"
              v-for="info in notif.informasi"
              :key="info.id_notifikasi"
              @click="handleInformation(info)"
            >
              <div slot="title">
                <h4 class="m-remove m-text-dots">{{ info.keperluan }}</h4>
                <small>{{ info.invoice_no }}</small>
              </div>
              <div slot="extra">
                <H-Status :status="info.deskripsi" />
              </div>
              <div class="d-flex flex-row justify-between">
                <span>{{ info.deskripsi + " By " + info.oleh }}</span>
                <!--                tempat status sebelumnya-->
              </div>
              <span>{{ info.tgl_notif }}</span>
            </a-card>
          </template>
          <a-alert type="error" message="Tidak Ada Informasi" banner v-else />
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-drawer>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import axios from "axios";
import Status from "@/components/Status.vue";
import HandleRoute from "@/mixins/HandleRoute";
import { addEventListener } from "../mixins/addEventListener";
import moment from "moment";

export default {
  name: "Notification",
  components: {
    "H-Status": Status,
  },
  mixins: [HandleRoute, addEventListener],
  props: {
    visible: Boolean,
  },
  data() {
    return {
      loading: true,
      activeKey: "aksi",
      search: "",
      notif: {
        aksi: [],
        informasi: [],
      },
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getNotification", "GET_HISTORY", "GET_PRIVATE"]),
    cleanDisplay() {
      if (this.activeKey === "informasi") {
        return true;
      } else {
        return false;
      }
    },
    searchNotif() {
      let output = JSON.parse(JSON.stringify(this.getNotification));
      if (this.search) {
        if (this.activeKey == "aksi") {
          output.aksi = output.aksi.filter(
            (item) =>
              (item.aksi &&
                item.aksi.toLowerCase().indexOf(this.search.toLowerCase()) >=
                  0) ||
              (item.invoice_no &&
                item.invoice_no
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (item.keperluan &&
                item.keperluan
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (item.sebagai &&
                item.sebagai.toLowerCase().indexOf(this.search.toLowerCase()) >=
                  0) ||
              (item.tgl_notif &&
                item.tgl_notif
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (item.tlc_pembuat &&
                item.tlc_pembuat
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (item.tipe &&
                item.tipe.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
          );
        } else {
          output.informasi = output.informasi.filter(
            (item) =>
              (item.deskripsi &&
                item.deskripsi
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (item.invoice_no &&
                item.invoice_no
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0) ||
              (item.tipe &&
                item.tipe.toLowerCase().indexOf(this.search.toLowerCase()) >=
                  0) ||
              (item.oleh &&
                item.oleh.toLowerCase().indexOf(this.search.toLowerCase()) >=
                  0) ||
              (item.tgl_notif &&
                item.tgl_notif
                  .toLowerCase()
                  .indexOf(this.search.toLowerCase()) >= 0)
          );
        }
      }

      return output;
    },
  },

  watch: {
    GET_PRIVATE() {
      this.FETCH_NOTIFICATION();
    },
    "getNotification.aksi"() {
      this.onSearch();
    },
    search() {
      if (this.search == "") {
        this.onSearch();
      }
    },
  },

  methods: {
    moment,
    ...mapActions({ FETCH_NOTIFICATION: "FETCH_NOTIFICATION" }),
    handleClose() {
      Event.$emit("notificationToggle");
    },
    fetchNotif() {
      this.$store.dispatch("SEND_EVENT", {
        type: "harmoniConnected",
        data: {
          tlc: this.getAuth.username,
          api: this.getAuth.apikey,
          password: this.getAuth.password,
        },
      });
    },
    handleInformation(payload) {
      axios({
        method: "put",
        url: this.$serviceUrl + "notifikasi/aksi",
        processData: false,
        data: {
          invoice_no: payload.invoice_no,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.FETCH_NOTIFICATION();
          this.handleNotification(payload);
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    handleClean() {
      axios({
        method: "put",
        url: this.$serviceUrl + "notifikasi/aksi",
        processData: false,
        data: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.FETCH_NOTIFICATION();
        })
        .catch((err) => {
          console.log("error : " + err);
        });
    },
    handleCleanDisplay() {
      alert("hello");
    },
    refresh() {
      alert("refresh");
    },
    mutatedNotif() {
      return this.getNotification;
    },
    onSearch() {
      this.notif = {
        aksi: this.searchNotif.aksi,
        informasi: this.searchNotif.informasi,
      };
    },
  },
  mounted() {
    Event.$on("refreshNotification", this.FETCH_NOTIFICATION);
    this.FETCH_NOTIFICATION();
    this.addEventListener("harmoniConnected", (user) => {
      this.$store.dispatch("RECEIVE_USERS", user);
    });
    this.fetchNotif();
    this.addEventListener("notifHrm", (msg) => {
      this.$store.dispatch("RECEIVE_PRIVATE", msg);
    });
  },
};
</script>

<style lang="less" scoped>
.m-drawer {
  &-notif {
    .ant-drawer-body {
      display: flex;
      overflow-y: auto!important;
    }
    .m-drawer-body {
      display: flex;
      flex: 1;
      border-top-right-radius: 0;
      .ant-tabs {
        overflow-x: hidden;
        overflow-y: auto!important;
      }
    }
    .ant-card-head-wrapper {
      align-items: flex-start;
    }
  }
}

.m-tabs {
  width: 100%;
  &-pane {
    padding: 0 @padding;
  }
}
</style>

<style lang="less" scoped>
.search-wrapper {
  width: 100%;
  padding: @padding;
  background-color: white;
}
</style>
